/* Bespoke page only: FAQ accordion and the enquiry form. */
(function () {
  /* one answer open at a time */
  var faqs = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* Front end only. There is no endpoint yet, so the form validates, shows a
     confirmation and stops &mdash; it must be pointed at a mail handler or CRM
     before launch. */
  var enq = document.getElementById('enquiryForm');
  if (!enq) return;
  enq.addEventListener('submit', function (e) {
    e.preventDefault();
    var missing = Array.prototype.slice.call(enq.querySelectorAll('[required]'))
      .filter(function (f) { return !f.value.trim(); });
    if (missing.length) {
      missing.forEach(function (f) { f.style.borderBottomColor = '#8C2F2F'; });
      missing[0].focus();
      return;
    }
    enq.classList.add('sent');
  });
  enq.addEventListener('input', function (e) {
    if (e.target.value.trim()) e.target.style.borderBottomColor = '';
  });
})();
